import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tokens/primitives.css';
import './tokens/semantic.css';

// When running as a Module Federation remote inside the CC portal, relative
// /api/* fetches would hit the host domain instead of the AQS backend.
// Patch window.fetch once so every service file works without modification.
const BE_URL = (import.meta.env.VITE_QS_BE_URL as string) ?? '';
if (BE_URL) {
  const _fetch = globalThis.fetch.bind(globalThis);
  globalThis.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (typeof input === 'string' && input.startsWith('/api/')) {
      return _fetch(BE_URL + input, init);
    }
    return _fetch(input, init);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
